import { Point, Rect } from './../../math';
import { Circle } from './../../svg';
import { isDefined } from './../../utils';
import { deepExtend } from './../../utils/deep-extend';
export class ConnectorVisual {
    constructor(connector) {
        this.options = deepExtend({}, connector.options);
        this._c = connector;
        this.visual = new Circle(this.options);
        this.refresh();
    }
    _hover(value) {
        const options = this.options, hover = options.hover;
        let stroke = options.stroke, fill = options.fill;
        if (value && isDefined(hover.stroke)) {
            stroke = deepExtend({}, stroke, hover.stroke);
        }
        if (value && isDefined(hover.fill)) {
            fill = hover.fill;
        }
        this.visual.redraw({
            stroke: stroke,
            fill: fill
        });
    }
    refresh() {
        var _a;
        const p = this._c.shape.diagram.modelToView(this._c.position()), relative = p.minus(this._c.shape.bounds('transformed').topLeft()), value = new Rect(p.x, p.y, 0, 0);
        // Include stroke width in hit area for easier dragging
        const strokeWidth = ((_a = this.options.stroke) === null || _a === void 0 ? void 0 : _a.width) || 0;
        const hitAreaPadding = strokeWidth / 2;
        // Add extra padding for easier connection dropping
        const extraDropZone = Math.max(this.options.width, this.options.height);
        value.inflate(this.options.width / 2 + hitAreaPadding + extraDropZone, this.options.height / 2 + hitAreaPadding + extraDropZone);
        this._visualBounds = value;
        this.visual.redraw({ center: new Point(relative.x, relative.y) });
    }
    _hitTest(p) {
        const tp = this._c.shape.diagram.modelToView(p);
        return this._visualBounds.contains(tp);
    }
}
